
import bitcoinjs from 'bitcoinjs-lib';
import { bufferHash } from './hasher.js';

const defaultState = Object.freeze({
        seed: "",
        pk: null,
        privateKey: "",
        wif: "",
        publicKey: "",
        publicAddress: "",
    });

export default function publicKeyReducer(state = defaultState, action = {type:'NO-OP'}) {
    switch( action.type ) {
        case 'PUBKEY-EDIT-SEED':
            return editSeed(state, action);
        case 'PUBKEY-GENERATE-PRIVATE-KEY':
            return generatePrivateKey(state, action);
        case 'PUBKEY-TOGGLE-WIF':
            return toggleWif(state, action);
        case 'PUBKEY-GENERATE-PUBLIC-KEY':
            return generatePublicKey(state, action);
        case 'PUBKEY-GENERATE-PUBLIC-ADDRESS':
            return generatePublicAddress(state, action);
        case 'PUBKEY-RESET':
            return resetAll(state, action);
        default:
            return state;
    }
}

function editSeed(state, action) {
    if( !action ) {
        return state;
    }

    return {
        ...state,
        seed: action.seed,
    };
}

function generatePrivateKey(state, action) {
    if( !state.seed ) {
        return state;
    }

    const h = bufferHash(state.seed),
        pk = bitcoinjs.ECPair.makeRandom({rng: () => h});

    return {
        ...state,
        pk: pk,
        privateKey: pk.d.toHex(),
    };
}

function toggleWif(state, action) {
    if( !state.pk ) {
        return state;
    }

    return {
        ...state,
        wif: state.wif ? "" : state.pk.toWIF(),
    };
}

function generatePublicKey(state, action) {
    if( !state.pk ) {
        return state;
    }

    return {
        ...state,
        publicKey: state.pk.getPublicKeyBuffer().toString('hex'),
    };
}

function generatePublicAddress(state, action) {
    if( !state.pk ) {
        return state;
    }

    return {
        ...state,
        publicAddress: state.pk.getAddress(),
    };
}

function resetAll(state, action) {
    return defaultState;
}





// WEBPACK FOOTER //
// ./src/reducers/publickey-reducer.js